// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.matrixGroups', {
    url: '/matrixgroups',
    templateUrl: 'main/configuration/matrixGroups/matrixGroups.tpl.html',
    data: { pageTitle: 'Matrix Groups' },
  });
};

angular.module('configuration.matrixGroups', []).config(config);
